/**
 * Marketing App - Landing Page & Public Site
 * WorkStream - Visão que move o trabalho
 */
import { Routes, Route, Navigate } from 'react-router-dom'

// Páginas principais
import Home from './pages/Home'
import Pricing from './pages/Pricing'
import Features from './pages/Features'

// Páginas de serviços
import PontoFacial from './pages/PontoFacial'
import ProdutividadePage from './pages/ProdutividadePage'
import IAComportamentalPage from './pages/IAComportamentalPage'
import SegurancaEPIPage from './pages/SegurancaEPIPage'

// Páginas por segmento
import ConstrucaoCivil from './pages/segments/ConstrucaoCivil'
import Telecomunicacoes from './pages/segments/Telecomunicacoes'
import Hospitais from './pages/segments/Hospitais'
import Industria from './pages/segments/Industria'
import Energia from './pages/segments/Energia'
import Logistica from './pages/segments/Logistica'

// Blog
import Blog from './pages/Blog'
import BlogPost from './pages/BlogPost'

export default function App() {
  return (
    <Routes>
      {/* Home */}
      <Route path="/" element={<Home />} />
      
      {/* Serviços */}
      <Route path="/ponto-facial" element={<PontoFacial />} />
      <Route path="/produtividade" element={<ProdutividadePage />} />
      <Route path="/ia-comportamental" element={<IAComportamentalPage />} />
      <Route path="/seguranca-epi" element={<SegurancaEPIPage />} />
      
      {/* Segmentos */}
      <Route path="/construcao-civil" element={<ConstrucaoCivil />} />
      <Route path="/telecomunicacoes" element={<Telecomunicacoes />} />
      <Route path="/hospitais" element={<Hospitais />} />
      <Route path="/industria" element={<Industria />} />
      <Route path="/energia" element={<Energia />} />
      <Route path="/logistica" element={<Logistica />} />
      
      {/* Blog */}
      <Route path="/blog" element={<Blog />} />
      <Route path="/blog/:slug" element={<BlogPost />} />
      
      {/* Outras páginas */}
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/precos" element={<Pricing />} />
      <Route path="/features" element={<Features />} />
      <Route path="/recursos" element={<Features />} />
      
      {/* Fallback */}
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  )
}

